// src/components/PresentationModal/PresentationModal.jsx
import { toSafeSimpleHtml } from "../../utils/safeHtml.js";
import "./PresentationModal.css";
//import { useState } from "react";
//import { X } from "lucide-react";

// Dans le composant
import { parseContentWithComponents } from "../../utils/parseContentMailto.js";

const PresentationModalPresentation = ({ content }) => {
  const titrPresentation = content?.presentationTitre || "nada.";

  const textPresentation = content?.presentation || "Aucun texte";

  const textAvertissement = content?.avertissement || "Aucun texte";

  const strPresentationTitle = toSafeSimpleHtml(titrPresentation);
  const strPresentation = toSafeSimpleHtml(textPresentation);

  const strAvertissement = toSafeSimpleHtml(textAvertissement);

  const illustration = `${process.env.PUBLIC_URL}/media/renelleau.jpg`;

  const parsedContent = parseContentWithComponents({
    mailtoButton: content?.mailtoButton,
  });

  return (
    <>
      <div className="presentation-content-wrapper">
        <div className="presentation-image-container">
          <img
            src={illustration}
            alt="Illustration"
            className="presentation-image"
          />
          <div className="presentation-caption">
            Thérèse et Dominique Renelleau
          </div>
        </div>
        <div
          className="presentation-content-title"
          dangerouslySetInnerHTML={{ __html: strPresentationTitle }}
        />
        <div
          className="presentation-content"
          dangerouslySetInnerHTML={{ __html: strPresentation }}
        />
      </div>
      <div
        className="avertissement-content"
        dangerouslySetInnerHTML={{ __html: strAvertissement }}
      />

      <div className="presentation-content-mail">{parsedContent}</div>
    </>
  );
};

export default PresentationModalPresentation;
